module.exports = __webpack_public_path__ + "static/media/paymentProcessing.238aa1a1.png";